import { FC, MouseEvent, ReactNode } from "react";
import { Typography } from "@material-ui/core";

import { Button } from "components";

const CookieConsentRequired: FC<{ message: ReactNode }> = ({ message }) => {
  return (
    <>
      <Typography gutterBottom>{message}</Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          // opening termly consent dialog requires a click on the termly display preferences button, it is rendered in react/orderbook/public/index.html
          document
            .querySelector<HTMLAnchorElement>(".termly-display-preferences")
            ?.click();
        }}
      >
        Update cookie settings
      </Button>
    </>
  );
};

export default CookieConsentRequired;
